<template>
  <div id="honor" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="out_honor"></div>
    <div class="container">
      <div class="organ mess" style="margin: 50px 0 0 0;">
        <el-link :underline="false">公司荣誉</el-link>
        <!-- <p style="font-size: 22px !important; font-weight: bolder;">HONORS</p> -->
      </div>
      <el-divider class="space"></el-divider>
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="公司荣誉" name="first">
            <el-row :gutter="10">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="(item,index) in arrDatah" :key="index">
                <el-card class="box-card">
                  <div class="covercontainer">
                    <img :src="item.src" />
                  </div>
                  <div class="title">{{item.title}}</div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="软件证书" name="second">
            <el-row :gutter="10">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="(item,index) in arrDataR" :key="index">
                <el-card class="box-card">
                  <div class="covercontainer">
                    <img :src="item.src" />
                  </div>
                  <div class="title">{{item.title}}</div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="人才培训" name="third">
            <el-row :gutter="10">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="(item,index) in arrDataP" :key="index">
                <el-card class="box-card">
                  <div class="covercontainer">
                    <img :src="item.src" />
                  </div>
                  <div class="title">{{item.title}}</div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="实习基地" name="fourth">
            <el-row :gutter="10">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="(item,index) in arrDataS" :key="index">
                <el-card class="box-card">
                  <div class="covercontainer">
                    <img :src="item.src" />
                  </div>
                  <div class="title">{{item.title}}</div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="世标证书" name="last">
            <el-row :gutter="10">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="(item,index) in arrLongData" :key="index">
                <el-card class="box-card card-long">
                  <img :src="item.src" />
                  <div class="title">{{item.title}}</div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          </el-row>
        </el-tabs>
      </template>
    </div>
    <filing></filing>
  </div>
</template>
<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'honor',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        activeName: 'first',
        arrLongData: [{
            src: require('@/assets/img/honor/honor15.jpg'),
            title: 'GB/T 28001职业健康安全管理体系认证'
          },
          {
            src: require('@/assets/img/honor/honor16.jpg'),
            title: 'ISO9001质量管理体系认证'
          },
          {
            src: require('@/assets/img/honor/honor17.jpg'),
            title: 'ISO14001环境管理体系认证'
          }
        ],
        arrDataR: [{
          src: require('@/assets/img/zhengshu/zhengshu1.jpg'),
          title: '2012年《GC-双语文档统一词汇智能检测软件》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu2.jpg'),
          title: '2012年《GC-公文信息归置软件》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu3.jpg'),
          title: '2012年《GC-服装进销存管理软件》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu4.jpg'),
          title: '2012年《GC-汽车维修技能多媒体培训系统》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu5.jpg'),
          title: '2014年《GC房产图档管理系统V2.0》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu6.jpg'),
          title: '2014年《GC汽车编写与智能DTP》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu7.jpg'),
          title: '2014年《GC汽车图档管理软件》证书'
        }, {
          src: require('@/assets/img/zhengshu/zhengshu8.jpg'),
          title: '2014年《GC人力资源人事管理软件》证书'
        }],
        arrDataP: [{
          src: require('@/assets/img/peixun/peixun1.jpg'),
          title: '河北省高技能人才培训基地'
        }, {
          src: require('@/assets/img/peixun/peixun2.jpg'),
          title: '河北省高校毕业生就业见习基地'
        }, {
          src: require('@/assets/img/peixun/peixun3.jpg'),
          title: '河北省民营企业人才培训基地'
        }, {
          src: require('@/assets/img/peixun/peixun4.jpg'),
          title: '辛集市就业局就业培训基地'
        }, {
          src: require('@/assets/img/peixun/peixun5.jpg'),
          title: '被共青团辛集市委授予青年见习培训基地'
        }, {
          src: require('@/assets/img/peixun/peixun6.jpg'),
          title: '2011年6月被河北省科学技术协会评为科技专家企业工作站'
        }],
        arrDatah: [{
            src: require('@/assets/img/honor/honor1.jpg'),
            title: '2004-2014年被认定为软件企业'
          },
          {
            src: require('@/assets/img/honor/honor2.gif'),
            title: '2004年2月荣获河北省科技企业'
          },
          {
            src: require('@/assets/img/honor/honor3.jpg'),
            title: '2011年被评为河北省服务外包企业'
          },
          {
            src: require('@/assets/img/honor/honor4.jpg'),
            title: '2004-2014年被认定为软件企业'
          },
          {
            src: require('@/assets/img/honor/honor5.jpg'),
            title: '河北省“十二五”制造业信息化科技工程试点企业'
          },
          {
            src: require('@/assets/img/honor/honor6.jpg'),
            title: '河北省第三、五、六届优秀软件企业'
          },
          {
            src: require('@/assets/img/honor/honor7.jpg'),
            title: '河北省软件与信息服务业协会第四届常务理事单位'
          },
          {
            src: require('@/assets/img/honor/honor8.jpg'),
            title: '重点保护工业企业'
          },
          {
            src: require('@/assets/img/honor/honor9.gif'),
            title: '2005年6月《GC-房产图档管理系统》荣获《河北省第二届优秀软件产品》称号'
          },
          {
            src: require('@/assets/img/honor/honor10.gif'),
            title: '2008年6月《GC-日文报刊建置管理系统软件》荣获《河北省第三届优秀软件产品》称号'
          },
          {
            src: require('@/assets/img/honor/honor11.jpg'),
            title: '2010年6月《GC-数据自动转换软件》荣获《河北省第四届优秀软件产品》称号'
          },
          {
            src: require('@/assets/img/honor/honor12.jpg'),
            title: '2012年5月《GC移动终端多媒体监控系统》荣获《河北省第五届优秀软件产品》称号'
          },
          {
            src: require('@/assets/img/honor/honor13.jpg'),
            title: '2012年度河北省科学技术进步三等奖'
          },
          {
            src: require('@/assets/img/honor/honor14.jpg'),
            title: '2014年3月《GC公文信息归置软件》荣获《河北省第六届优秀软件产品》称号'
          }
        ],
        arrDataS: [{
          src: require('@/assets/img/shixi/shixi1.jpg'),
          title: '河北经贸大学外国语学院教育教学实习基地'
        }, {
          src: require('@/assets/img/shixi/shixi2.jpg'),
          title: '河北科技大学外国语学院教育教学实习基地'
        }, {
          src: require('@/assets/img/shixi/shixi3.jpg'),
          title: '石家庄铁道学院外语系教育教学实习基地'
        }, {
          src: require('@/assets/img/shixi/shixi4.jpg'),
          title: '河北师范大学外国语学院教育教学实习基地'
        }, {
          src: require('@/assets/img/shixi/shixi5.jpg'),
          title: '被共青团辛集市委授予青年见习培训基地'
        }],
      }
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
    },
    methods: {
      handleClick() {

      }
    },
  }
</script>
<style>
  #honor .text {
    font-size: 14px;
  }

  #honor .item {
    padding: 18px 0;
  }

  #honor .box-card {
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 50px;
    min-height: 340px;
  }

  #honor .card-long {
    min-height: 520px !important;
  }

  #honor .box-card:hover {
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  #honor .el-card__body {
    padding: 0 5px !important;
    padding-top: 15px !important;
  }

  #honor .el-card__body img {
    width: 100%;
    height: auto;
  }

  #honor .title {
    width: 100%;
    text-align: center;
    padding: 20px;
  }

  #honor .el-tabs__active-bar {
    width: 0 !important;
  }


  #honor .el-tabs__nav-wrap::after {
    background-color: transparent;
  }

  #honor .el-tabs__nav {
    float: none !important;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 15px 0;
    margin-bottom: 20px;
    text-align: center;
  }

  #honor .el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
  }

  #honor .el-tabs__item {
    margin: 0 30px;
  }

  #honor .el-tabs__nav-prev,
  #honor .el-tabs__nav-next {
    font-size: 18px;
    line-height: 70px;
  }

  #honor div.space {
    height: 3px !important;
    position: relative;
  }

  #honor .covercontainer {
    height: 220px;
  }

  #honor div.space:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  #honor .el-tabs__nav {
    overflow-x: auto;
  }

  @media (max-width: 800px) {
    #honor .el-tabs__item {
      margin: 0 2px !important;
    }
    #honor .covercontainer {
      height: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_honor.vue